/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgExtendableItem = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m6.22 12.375-.066.091A1 1 0 0 0 7 14h2.718L8.03 20.757c-.26 1.036 1.068 1.703 1.744.876l9-11 .067-.09A1 1 0 0 0 18 9h-2.848l.838-5.859c.144-1.008-1.135-1.56-1.77-.766zm7.272-5.891-.482 3.375-.01.112A1 1 0 0 0 14 11h1.889l-4.836 5.911.917-3.668.021-.112A1 1 0 0 0 11 12H9.079z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgExtendableItem as ExtendableItem };
